module.exports = __webpack_public_path__ + "img/chechDb-selected.96a7e899.png";